module.exports = __webpack_public_path__ + "media/images/mailer-report-image-02f81ecc61ecfcb8a9fe425e0285da45.png";